<div class="font-roboto-700 mb-4 max-sm:mb-2 max-sm:text-11">
  <div class="flex items-center">
    <a [routerLink]="getSoccerCompetitionUrl()" class="flex-shrink-0">
      <div
        class="flex items-center gap-2 max-sm:gap-1 cursor-pointer hover:underline"
      >
        <img
          alt="sportLogo"
          class="w-[25px] h-[25px] object-contain max-sm:w-[19px] max-sm:h-[19px]"
          [src]="getSoccerIcon()"
        />
        <div>
          {{ "Sports.Football" | translate }}
        </div>
      </div>
    </a>

    <!-- Check if there is competition -->
    <div class="mx-2 flex-shrink-0">
      <img alt="right-pointer" [src]="urlIcon + 'right-pointer.svg'" />
    </div>

    <a [routerLink]="[getCompetitionUrl()]" class="flex-grow overflow-hidden">
      <div
        class="flex items-center gap-2 max-sm:gap-1 cursor-pointer hover:underline"
      >
        @if (getCompetitionLogo() != "") {
        <img
          alt="competitionLogo"
          class="w-[25px] h-[25px] rounded-full object-contain"
          [src]="getCompetitionLogo()"
        />
        }
        <div class="truncate">
          {{ getCompetitionName() }}
        </div>
      </div>
    </a>
  </div>
</div>
